import { ExternalAttendee, ExternalAttendeesService, ISearchExternalAttendeesParameters } from '@jooxter/api';
import { useQuery } from '@tanstack/react-query';
import { ExternalAttendeeQueryKeys } from '../queryKeys';
import { ExternalAttendeeStaleTimeEnum } from '../staleTimes';

export const useFetchExternalAttendeesSearch = (
  options: ISearchExternalAttendeesParameters,
  enabled = true
): {
  externalAttendees: ExternalAttendee[];
  isLoading: boolean;
  isError: boolean;
} => {
  const { data, isLoading, isError } = useQuery({
    queryKey: [ExternalAttendeeQueryKeys.GetExternalAttendeesSearch, options],
    queryFn: () => ExternalAttendeesService.getExternalAttendeesWithPagination(options),
    staleTime: ExternalAttendeeStaleTimeEnum.GetExternalAttendeesSearch,
    enabled,
  });

  return { externalAttendees: data?.data ?? [], isLoading, isError };
};
